import { connect } from 'react-redux';
import SendMessage from 'Components/Groups/SendMessage';

function mapStatetoProps(state){
    return{
        
    } 
}

const mapDispatchtoProps = {
}

export default connect(mapStatetoProps,mapDispatchtoProps)(SendMessage)